export const isIos = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};
